import styles from './ReviewCard.module.scss'
import classNames from 'classnames'
import { useGetProductCatalogMutation } from '@/shared/api-rtk/index.js'
import { useEffect, useState } from 'react'
import Link from 'next/link'

import { Card, Placeholder } from 'react-bootstrap'


export function ReviewCard({ item, showProductLink = true }) {
    const [getProduct, { isLoading }] = useGetProductCatalogMutation()
    const [product, setProduct] = useState([])
    const [isClicked, setIsClicked] = useState(false)

    const handleClick = () => {
        setIsClicked((prevState) => !prevState) // Переключаем состояние
    }

    useEffect(() => {
        if (product.length) return
        getProduct(item.product_id)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setProduct(Object.values(res.data))
                }
            })
    }, [])

    const reviewDate = item.date_modified
        .split(' ')[0]
        .split('-')
        .reverse()
        .join('.')
    return !product.length ? (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <Placeholder xs={1} as={Card.Title} />
                <Placeholder xs={1} as={Card.Title} />
            </div>
            <div className={styles.itemText}>
                <Placeholder as={Card.Text} animation="glow">
                    <Placeholder xs={7} /> <Placeholder xs={4} />{' '}
                    <Placeholder xs={3} /> <Placeholder xs={5} />
                </Placeholder>
            </div>
        </div>
    ) : (
        <div
            className={classNames(
                styles.wrapper,
                !showProductLink && styles.smallCard
            )}
        >
            <div className={styles.info}>
                <div className={classNames(styles.header)}>
                    <div className={classNames(styles.name)}>{item.author}</div>
                    <div className={classNames(styles.date)}>{reviewDate}</div>
                </div>
                <div
                    className={`${styles.text} ${
                        isClicked ? styles.active : ''
                    }`}
                    onClick={handleClick}
                >
                    {item.text}
                </div>
            </div>
            {showProductLink && (
                <Link
                    className={styles.productHref}
                    href={'/' + product[0].url}
                >
                    {product[0].name}
                </Link>
            )}
        </div>
    )
}
